export default "__VITE_ASSET__Cr7jYi24__"